import service from '@/utils/request'

/** 获取本地商家分页列表 */
export function getStorePages(params) {
  return service.get('/backend/store/page', { params })
}

/** 获取本地商家所有列表 */
export function getStoreList(params) {
  return service.get('/backend/store/list', { params })
}

/** 获取商家详情 */
export function getStoreDetail(storeId) {
  return service.get(`/backend/store/detail?id=${storeId}`)
}

/** 提交保存商家资料 */
export function submitStoreInfo(data) {
  return service.post(`/backend/store/submit`, data)
}

/** 更新商家状态 */
export function updateStatus(data) {
  return service.put(`/backend/store/status`, data)
}

/** 删除商家 */
export function removeStore(data) {
  return service.put(`/backend/store/remove`, data)
}

/** 重置商家密码 */
export function resetPassword(data) {
  return service.put(`/backend/store/reset`, data)
}

/** 商家审核 */
export function approveStore(data) {
  return service.put(`/backend/store/approve`, data)
}

/** 获取本地商家商品列表 */
export function getGoods(params) {
  return service.get(`/backend/store/goods/list`, { params })
}

/** 获取商品详情 */
export function getGoodsDetail(params) {
  return service.get(`/backend/store/goods/detail`, { params })
}

/** 提交保存商品资料 */
export function submitGoods(data) {
  return service.post(`/backend/store/goods/detail`, data)
}

/** 更新商品审核状态 */
export function approveGoods(data) {
  return service.put(`/backend/store/goods/approve`, data)
}

/** 商品上/下架 */
export function putGoodOnsale(data) {
  return service.put(`/backend/store/goods/onsale`, data)
}

/** 获取店员列表 */
export function getEmployeeList(params) {
  return service.get(`/backend/store/employee/list`, { params })
}

/** 获取店员详情 */
export function getEmployeeDetail(employeeId, userId) {
  return service.get(`/backend/store/employee/detail?id=${employeeId}&userId=${userId}`)
}

/** 提交保存店员资料 */
export function submitEmployee(data) {
  return service.post(`/backend/store/employee/detail`, data)
}

/** 更新店员资料 */
export function updateEmployee(data) {
  return service.put(`/backend/store/employee/detail`, data)
}

/** 删除店员资料 */
export function removeEmployee(employeeId) {
  return service.delete(`/backend/store/employee/detail?employeeId=${employeeId}`)
}

/** 重置店员密码 */
export function resetEmployeePassword(data) {
  return service.post(`/backend/store/employee/reset`, data)
}
